export default defineNuxtPlugin(() => {
  const isCrispOpened = useState('crisp:opened', () => false)

  window.$crisp = []
  window.CRISP_WEBSITE_ID = 'f27054a5-2157-4277-a935-a2e40ca00dc1'

  ;(function () {
    const document = window.document
    const script = document.createElement('script')

    script.src = 'https://client.crisp.chat/l.js'
    script.async = true
    document.querySelectorAll('head')[0].append(script)

    // Disable crisp warnings
    window.$crisp.push(['safe', true])

    // Track chatbox opening state
    window.$crisp.push([
      'on',
      'chat:opened',
      () => isCrispOpened.value = true,

    ])

    // Track chatbox closing state
    window.$crisp.push([
      'on',
      'chat:closed',
      () => isCrispOpened.value = false,
    ])
  })()
})
